import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import MaterialIcon from '../../../../components/MaterialIcon';

import {download} from '../../../lessons/actionCreators/medium';

const DownloadButton = ({files, percent, onClick}) => {
    if (files.length === 0) return null;

    let child;

    if (percent === null) {
        child = <MaterialIcon type="cloud_download" />;
    } else if (percent === 100) {
        child = <MaterialIcon type="check" />;
    } else {
        child = `${percent}%`;
    }

    return (
        <span className="secondary-content" onClick={onClick}>
            {child}
        </span>
    );
};

DownloadButton.propTypes = {
    files: PropTypes.arrayOf(PropTypes.string).isRequired,
    percent: PropTypes.number,
    onClick: PropTypes.func,
};

DownloadButton.defaultProps = {
    percent: null,
    onClick: null,
};

const mapDispatchToProps = (dispatch, {files, percent}) => {
    if (typeof percent === 'number') return {};

    return {
        onClick: event => {
            event.preventDefault();
            event.stopPropagation();
            files.forEach(remote => dispatch(download(remote)));
        },
    };
};

export default connect(undefined, mapDispatchToProps)(DownloadButton);



// WEBPACK FOOTER //
// ./scripts/frontend/questionnaires/components/DownloadButton/DownloadButton.js